import { useContext } from 'react';
import { UsageTrackerContext } from '../context/UsageTrackerContext';
export function useUsageTracker() {
  const tracker = useContext(UsageTrackerContext);
  if (!tracker) {
    throw new Error('useUsageTracker must be used within a UsageTrackerProvider');
  }
  return tracker;
}